<template>
  <div id="uncombat_knockout">uncombat_knockout</div>
</template>

<script>
export default {
  name: 'uncombat_knockout',
  props: {
    datas: {
      type: Object,
      default: () => null,
    },
  },
  data() {
    return {}
  },
}
</script>

<style lang="scss" scoped>
#uncombat_knockout {
}
</style>
